import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 15h12l-12 -12h12v6h-12v6l6 6v-6","key":"svg-0"}]]

const IconBrandFramer = createReactComponent('outline', 'brand-framer', 'BrandFramer', __iconNode);

export default IconBrandFramer;